import { useEffect, useState } from 'react';
import { useTheme } from '@/contexts/ThemeContext';
import { Link } from 'react-router-dom';
import { tokens } from '../theme';

/**
 * CookieBanner — aviso de cookies con consentimiento (Fase 5). Ofrece "Solo esenciales" a la par de
 * "Aceptar" (privacidad primero). Persiste la elección en localStorage (try/catch por si está bloqueado)
 * y no vuelve a aparecer. Temizado día/noche.
 */
const KEY = 'leadcem_cookie_consent';

export default function CookieBanner() {
  const { theme } = useTheme();
  const t = tokens(theme);
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setShow(true);
    } catch (e) {
      setShow(true);
    }
  }, []);

  const decide = (v) => {
    try { localStorage.setItem(KEY, v); } catch (e) { /* almacenamiento bloqueado: se cierra igual */ }
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      className={`fixed left-3 right-3 bottom-3 z-[70] mx-auto max-w-xl rounded-2xl p-4 sm:p-5 shadow-2xl ${t.glass}`}
      role="dialog"
      aria-label="Aviso de cookies"
      data-testid="cookie-banner"
    >
      <div className="flex flex-col sm:flex-row sm:items-center gap-3">
        <p className={`text-xs leading-relaxed ${t.textSub} flex-1`}>
          Usamos cookies para que la página funcione y para medir su desempeño. Puedes aceptar todas o quedarte solo con las esenciales.
          Más en la <Link to="/privacidad" className={`underline ${t.accentText}`}>Política de Privacidad</Link>.
        </p>
        <div className="flex gap-2 shrink-0">
          <button
            onClick={() => decide('essential')}
            className={`text-xs rounded-full px-4 h-9 border ${t.dark ? 'border-white/20 text-white/80 hover:bg-white/10' : 'border-slate-300 text-slate-700 hover:bg-slate-100'}`}
            data-testid="cookie-essential"
          >
            Solo esenciales
          </button>
          <button
            onClick={() => decide('all')}
            className="text-xs rounded-full px-4 h-9 bg-lime-400 hover:bg-lime-300 text-slate-950 font-semibold"
            data-testid="cookie-accept"
          >
            Aceptar
          </button>
        </div>
      </div>
    </div>
  );
}
